// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3831":"e57a60d9","8562":"c3d9f954","9163":"c3d9f954"}[chunkId] + ".css";
};